import {
  DEFERRAL_LIMIT_BUSINESS_DAYS,
  JP_HOLIDAYS,
} from './constants'

const JAPAN_TIME_ZONE = 'Asia/Tokyo'
const JAPAN_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeZone: JAPAN_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

function japanDate(now: Date): string {
  if (Number.isNaN(now.getTime())) {
    throw new Error('now は有効な日時にしてください')
  }

  const parts = JAPAN_DATE_FORMATTER.formatToParts(now)
  const year = parts.find((part) => part.type === 'year')?.value
  const month = parts.find((part) => part.type === 'month')?.value
  const day = parts.find((part) => part.type === 'day')?.value

  if (year === undefined || month === undefined || day === undefined) {
    throw new Error('日本時間の日付を生成できませんでした')
  }

  return `${year}-${month}-${day}`
}

function addCalendarDays(date: string, days: number): string {
  const [year, month, day] = date.split('-').map(Number)
  const next = new Date(Date.UTC(year, month - 1, day + days))
  return next.toISOString().slice(0, 10)
}

export function isBusinessDay(date: string): boolean {
  const dayOfWeek = new Date(`${date}T00:00:00Z`).getUTCDay()
  return dayOfWeek !== 0 && dayOfWeek !== 6 && !JP_HOLIDAYS.has(date)
}

export function shipDateCandidates(
  now: Date,
  horizonBusinessDays: number = DEFERRAL_LIMIT_BUSINESS_DAYS,
): string[] {
  if (
    !Number.isInteger(horizonBusinessDays)
    || horizonBusinessDays < 0
    || horizonBusinessDays > DEFERRAL_LIMIT_BUSINESS_DAYS
  ) {
    throw new Error(
      `horizonBusinessDays は0〜${DEFERRAL_LIMIT_BUSINESS_DAYS}の整数にしてください`,
    )
  }

  const candidates: string[] = []
  let candidate = japanDate(now)

  while (candidates.length < horizonBusinessDays) {
    candidate = addCalendarDays(candidate, 1)
    if (isBusinessDay(candidate)) {
      candidates.push(candidate)
    }
  }

  return candidates
}
